import MicroModal from 'micromodal';

export default function init()
{

    setTimeout(function() {

        document.querySelectorAll('.notation-trigger').forEach(link =>
            link.addEventListener('click', (e) => {

                e.preventDefault();

                var modal = link.dataset.micromodalTrigger;

                MicroModal.show(modal);
            })
        )

    }, 1000);

}


